const variantCache = {};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      form: this.querySelector('form'),
      button: this.querySelector('button[type="submit"]'),
      variants: this.querySelector('.variant-form'),
    };

    this.elements.form.querySelector('[name=id]').disabled = false;
    this.cart = document.querySelector('cart-drawer');
    this.hideErrors = this.elements.form.dataset.hideErrors === 'true';

    this.elements.form.addEventListener('submit', this.handleAjaxButton.bind(this));

    if (this.elements.variants) {
      this.elements.variants.addEventListener('change', this.handleVariantChange.bind(this));
    }
  }

  handleAjaxButton(e) {
    e.preventDefault();

    this.handleErrorMessage();

    this.elements.button.setAttribute('aria-disabled', true);
    this.elements.button.classList.remove('added');
    this.elements.button.classList.add('loading');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.elements.form);
    
    // Forçar o valor correto da quantidade
    const quantityInput = this.elements.form.querySelector('input[name="quantity"]');
    if (quantityInput) {
      const quantity = parseInt(quantityInput.value) || 1;
      formData.set('quantity', quantity.toString());
    }
    
    if (this.cart) {
      formData.append(
        'sections',
        this.cart.getSectionsToRender().map((section) => section.section)
      );
      formData.append('sections_url', window.location.pathname);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);
          this.elements.button.setAttribute('aria-disabled', true);
          this.elements.button.querySelector('span').classList.add('disabled');
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: '.add-to-cart-form',
            productVariantId: formData.get('id'),
            cartData: response,
          });
        this.error = false;

        this.cart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.elements.button.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) {
          this.elements.button.removeAttribute('aria-disabled');
          this.elements.button.classList.add('added');

          setTimeout(() => this.elements.button.classList.remove('added'), 1000);
        }
      });
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    if (typeof errorMessage !== 'string') return;

    this.errorMessageWrapper =
      this.errorMessageWrapper || this.elements.form.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  handleVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantStatuses();
    this.updateVariantInput();
    this.updateURL();
    this.renderProductInfo();
  }

  updateOptions() {
    if (this.elements.variants.classList.contains('variant-radios-form')) {
      const fieldsets = Array.from(this.elements.variants.querySelectorAll('.product-form__input'));

      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    } else {
      this.options = Array.from(this.elements.variants.querySelectorAll('select'), (select) => select.value);
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.elements.variants.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateVariantInput() {
    const input = this.elements.form.querySelector('input.product-variant-id');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.elements.variants.querySelector(':checked').value === variant.option1
    );

    const inputWrappers = [...this.elements.variants.querySelectorAll('.product-form__input')];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        if (this.elements.variants.classList.contains('variant-radios-form')) {
          input.classList.remove('disabled');
          input.removeAttribute('disabled');
        } else {
          input.innerText = input.getAttribute('value');
        }
      } else {
        if (this.elements.variants.classList.contains('variant-radios-form')) {
          input.classList.add('disabled');
          input.setAttribute('disabled', '');
        } else {
          input.innerText = window.variantStrings.unavailable_with_option.replace(
            '[value]',
            input.getAttribute('value')
          );
        }
      }
    });
  }

  updateURL() {
    if (!this.currentVariant || this.elements.variants.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.elements.variants.dataset.url}?variant=${this.currentVariant.id}`);
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.elements.variants.dataset.originalSection
      ? this.elements.variants.dataset.originalSection
      : this.elements.variants.dataset.section;
    this.elements.button.removeAttribute('aria-disabled');

    if (variantCache[requestedVariantId]) {
      this.updateProductInfo(variantCache[requestedVariantId]);
      return;
    }

    this.elements.form.classList.add('fetching');

    fetch(`${this.elements.variants.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        variantCache[requestedVariantId] = html;
        this.updateProductInfo(html);
        this.elements.form.classList.remove('fetching');
      });
  }

  updateProductInfo(html) {
    const sectionId = this.elements.variants.dataset.originalSection
      ? this.elements.variants.dataset.originalSection
      : this.elements.variants.dataset.section;
    const newProductInfo = html.getElementById(`ProductInfo-${sectionId}`);
    const newProductGallery = html.getElementById(`ProductGallery-${sectionId}`);
    const productInfo = document.getElementById(`ProductInfo-${sectionId}`);
    const productGallery = document.getElementById(`ProductGallery-${sectionId}`);

    if (productInfo && newProductInfo) {
      productInfo.innerHTML = newProductInfo.innerHTML;
    }

    if (productGallery && newProductGallery) {
      productGallery.replaceWith(newProductGallery.cloneNode(true));
    }

    publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        sectionId,
        html,
        variant: this.currentVariant,
      },
    });
  }
}

customElements.define('product-form', ProductForm);
